import * as React from 'react'
import PropTypes from 'prop-types'
import cls from './EventsTabPlaceholder.module.scss'

const EventsTabPlaceholder = ({ onButtonClick, buttonText, title }) => (
  <div className={cls.placeholderContainer}>
    <div className={cls.placeholderContent}>
      <h3>{title}</h3>
      <button className={cls.mainButton} onClick={onButtonClick}>
        {buttonText}
      </button>
    </div>
  </div>
)

EventsTabPlaceholder.propTypes = {
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
  title: PropTypes.string,
}

EventsTabPlaceholder.defaultProps = {
  buttonText: 'New Event',
}

export default EventsTabPlaceholder
